import styled from "styled-components";

export const BrandContainer = styled.li`
  font-size: 1.5rem;
  font-weight: bold;
  color: ${(props) => props.theme.nav.horizontal.nav.color};
  margin-right: 0.5rem;
  margin-left: 0.5rem;
  max-height: 40px;
`;
